import { call, put, takeLatest } from 'redux-saga/effects';
import { callWithAuth } from '../sagaApiHelper';
import { whatsappEmbeddedSignupApi } from '../../api/apiLists/whatsappEmbeddedSignupApi';
import { showAlert } from '../alertSlice';
import { setLoading, setSuccess, setLastPayload } from '../whatsappSignupSlice';

function* handleEmbeddedSignup(action) {
  try {
    yield put(setLoading(true));
    const payload = action.payload || {};

    const nestedData = payload.data || {};
    const transformedPayload = {
      code: payload.code,
      events: [
        {
          data: {
            phone_number_id: payload.phone_number_id || nestedData.phone_number_id || '',
            waba_id: payload.waba_id || nestedData.waba_id || '',
            business_id: payload.business_id || nestedData.business_id || ''
          },
          type: payload.type || '',
          event: payload.event || ''
        }
      ]
    };


    const res = yield call(callWithAuth, whatsappEmbeddedSignupApi, { operation: 'WA_EMBEDDED_SIGNUP', payload: transformedPayload });


    if (res?.status === true) {
      yield put(setSuccess(true));
      yield put(setLastPayload(transformedPayload));
      yield put({ type: 'FETCH_WABA_IDS', payload: { poll: true } });
    } else {
      yield put(setSuccess(true));
      yield put(setLastPayload(transformedPayload));
      yield put(showAlert({ message: 'Signup failed', type: 'error' }));
    }
  } catch (err) {
    yield put(showAlert({ message: 'Signup error', type: 'error' }));
  } finally {
    yield put(setLoading(false));
  }
}

export default function* whatsappSignupSaga() {
  yield takeLatest('START_EMBEDDED_SIGNUP', handleEmbeddedSignup);
}
